import React from 'react';
import PropTypes from "prop-types";
import {Form} from "react-bootstrap";

function DDMMYYYY(props) {
    props.elementProps.onKeyPress = function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            return e.target.blur()
        }
        if (e.key === 'Backspace' || e.keyCode === 8) {
            return
        }
        // if the cursor is at the end of the field, format to a date like string
        if (e.target.value.length === e.target.selectionStart && e.target.selectionEnd - e.target.selectionStart === 0) {
            e.preventDefault()
            let orig = e.target.value
            const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
            const charStr = String.fromCharCode(charCode);
            const temp = orig + '' + charStr

            // prevent if not a digit or slash
            if (!(/\d/.test(charStr)) && charStr !== '/') {
                return false
            }

            //only allow a slash if the day or month is 1 char len
            if (charStr === '/') {
                if ([1, 7].includes(orig.length)) {
                    formatDate(temp)
                } else {
                    return false
                }
            }
            e.target.value = formatDate(temp)
        }
        function formatDate(str) {
            const parts = str.split('/')
            const newParts = parts.map((part, i) => {
                part = part.trim()
                // add leading zeros to days and months and prevent invalid
                if ([0, 1].includes(i)) {
                    if (part.length === 1) {
                        if ((i === 0 && (parseInt(part) > 3 || parts.length > 1)) || (i === 1 && (parseInt(part) > 1 || parts.length > 2))) {
                            return '0' + part
                        }
                    }
                    if ((i === 0 && part > 31) || (i === 1 && part > 12)) {
                        part = part.slice(0, -1)
                    }
                }
                // prevent invalid years
                else {
                    if (i === 2) {
                        const maxYear = ((new Date()).getFullYear() + 49).toString().slice(0, -1)
                        // detect and correct YY format to YYYY
                        if ([5,6,7,8,9].includes(parseInt(part))){
                            part = 190 + parseInt(part)
                        }
                        if ([0].includes(parseInt(part))){
                            part = 200 + parseInt(part)
                        }
                        part = part.toString()
                        // prevent starting a year incorrectly
                        if (
                            (part.length === 1 && ![1, 2].includes(parseInt(part))) ||
                            (part.length === 2 && ![19, 20].includes(parseInt(part))) ||
                            (part.length === 3 && (parseInt(part) < 195 || parseInt(part) > maxYear))) {
                            part = part.slice(0, -1)
                        }
                    }
                }
                return part.trim()
            })
            if ((newParts.length === 1 && newParts[0].length === 2) || (newParts.length === 2 && newParts[1].length === 2)) {
                newParts.push('')
            }
            return newParts.join(' / ')
        }
    }
    props.elementProps.onKeyUp = function (e) {
        if (e.key === 'Backspace' || e.keyCode === 8) {
            e.target.value = e.target.value.split(' / ').filter(part => {
                return part.trim() !== ''
            }).join(' / ')
        }
    }
    props.elementProps.onBlur = function (e) {
        props.setAnswer(e.target.value.split(' / ').reverse().join('-'))
    }
    props.elementProps.defaultValue = !!props.elementProps.defaultValue ? props.elementProps.defaultValue.split('-').reverse().join(' / ') : ''
    props.elementProps.placeholder = 'DD / MM / YYYY'
    return (<Form.Control type="tel" {...props.elementProps} />)
}
DDMMYYYY.propTypes = {
    elementProps: PropTypes.object,
    setAnswer: PropTypes.func,
};
export default DDMMYYYY;